import { Position } from './Transform/Position';
import { Rotation } from './Transform/Rotation';
export class Vector {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    static fromPos(pos1, pos2) {
        return new Vector(pos2.x - pos1.x, pos2.y - pos1.y);
    }
    set angle(angle) {
        const pos = Rotation.rotatePoint(angle, new Position(this.norm, 0), new Position(0, 0));
        this.x = pos.x;
        this.y = pos.y;
    }
    get angle() {
        const ref = new Vector(1, 0);
        let a = this;
        if (this.y > 0) {
            a = a.clone().invert();
        }
        let angle = Math.acos(a.dot(ref) / (a.norm * ref.norm));
        if (this.y > 0) {
            angle += Math.PI;
        }
        return angle;
    }
    // Produit scalaire et norme euclidienne calcules directement : ils
    // passaient par `dot` et `norm` de mathjs, soit toute la librairie tiree
    // dans le bundle (212 Ko, 66 Ko gzip) pour deux operations 2D triviales.
    // Resultats numeriquement identiques, verifies face a mathjs sur des cas
    // limites (zero, grandes et tres petites valeurs).
    dot(vector) {
        return this.x * vector.x + this.y * vector.y;
    }
    get norm() {
        return Math.hypot(this.x, this.y);
    }
    set norm(norm) {
        const factor = norm / this.norm;
        this.x *= factor;
        this.y *= factor;
    }
    invert() {
        this.x *= -1;
        this.y *= -1;
        return this;
    }
    clone() {
        return new Vector(this.x, this.y);
    }
    toArray() {
        return [this.x, this.y];
    }
    projectOn(v) {
        const u = this;
        const proj = u.dot(v) / Math.pow(v.norm, 2);
        return new Vector(v.x * proj, v.y * proj);
    }
}
